import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const DashboardPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    announcements: [],
    events: [],
    statistics: {
      totalUsers: 0,
      totalAnnouncements: 0,
      totalDocuments: 0,
      totalProjects: 0
    },
    recentActivity: [],
    birthdays: []
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      console.log('Dashboard verileri yükleniyor...');
      
      // Count endpoint'inden tüm verileri çek
      const countData = await api.getCounts();
      console.log('Count API çağrısı başarılı:', countData);

      console.log('Count API Yanıtı:', countData);

      // Count data'dan verileri al
      const statistics = countData.data?.statistics || {
        totalUsers: 0,
        totalAnnouncements: 0,
        totalDocuments: 0,
        totalProjects: 0
      };

      const recentBirthdays = countData.data?.recentBirthdays || [];
      const recentActivity = countData.data?.recentActivity || [];
      const latestAnnouncements = countData.data?.latestAnnouncements || [];

      // Fallback duyurular (API'den veri gelmezse)
      const fallbackAnnouncements = [
        {
          title: 'Yeni İş Sağlığı ve Güvenliği Yönetmeliği',
          content: 'Tüm personelin dikkatine: Yeni İş Sağlığı ve Güvenliği yönetmeliği yürürlüğe girmiştir.',
          createdAt: new Date().toISOString(),
          author: { firstName: 'Can', lastName: 'Bilgi' }
        },
        {
          title: 'Geleneksel Yıl Sonu Pikniği',
          content: 'Tüm personelimizi geleneksel yıl sonu pikniğimize davet ediyoruz.',
          createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          author: { firstName: 'Can', lastName: 'Bilgi' }
        },
        {
          title: 'Kolin İnşaat Proje Başarısı',
          content: 'Kolin İnşaat olarak Kuzey Marmara Otoyolu Projesi\'ni başarıyla tamamladık.',
          createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
          author: { firstName: 'Can', lastName: 'Bilgi' }
        }
      ];

      const finalDashboardData = {
        announcements: latestAnnouncements.length > 0 ? latestAnnouncements : fallbackAnnouncements,
        events: [], // Events henüz implement edilmedi
        statistics,
        recentActivity,
        birthdays: recentBirthdays
      };

      setDashboardData(finalDashboardData);

    } catch (error) {
      console.error('Dashboard verileri yüklenirken hata:', error);
      
      // Hata durumunda fallback verilerle dashboard'u göster
      const fallbackAnnouncements = [
        {
          title: 'Yeni İş Sağlığı ve Güvenliği Yönetmeliği',
          content: 'Tüm personelin dikkatine: Yeni İş Sağlığı ve Güvenliği yönetmeliği yürürlüğe girmiştir.',
          createdAt: new Date().toISOString(),
          author: { firstName: 'Can', lastName: 'Bilgi' }
        },
        {
          title: 'Geleneksel Yıl Sonu Pikniği',
          content: 'Tüm personelimizi geleneksel yıl sonu pikniğimize davet ediyoruz.',
          createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          author: { firstName: 'Can', lastName: 'Bilgi' }
        }
      ];

      setDashboardData({
        announcements: fallbackAnnouncements,
        events: [],
        statistics: {
          totalUsers: 0,
          totalAnnouncements: fallbackAnnouncements.length,
          totalDocuments: 0,
          totalProjects: 0
        },
        recentActivity: [],
        birthdays: []
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-dashboard">
      {/* Modern Header Cards */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="modern-dashboard-header">
            <div className="modern-stat-card">
              <div className="modern-stat-icon">
                <i className="bx bxs-user-circle"></i>
              </div>
              <div className="modern-stat-content">
                <h3 className="modern-stat-number">{dashboardData.statistics.totalUsers}</h3>
                <p className="modern-stat-label">Toplam Kullanıcı</p>
              </div>
            </div>
            
            <div className="modern-stat-card">
              <div className="modern-stat-icon">
                <i className="bx bxs-megaphone"></i>
              </div>
              <div className="modern-stat-content">
                <h3 className="modern-stat-number">{dashboardData.statistics.totalAnnouncements}</h3>
                <p className="modern-stat-label">Duyuru</p>
              </div>
            </div>
            
            <div className="modern-stat-card">
              <div className="modern-stat-icon">
                <i className="bx bxs-file-doc"></i>
              </div>
              <div className="modern-stat-content">
                <h3 className="modern-stat-number">{dashboardData.statistics.totalDocuments}</h3>
                <p className="modern-stat-label">Doküman</p>
              </div>
            </div>
            
            <div className="modern-stat-card">
              <div className="modern-stat-icon">
                <i className="bx bxs-briefcase"></i>
              </div>
              <div className="modern-stat-content">
                <h3 className="modern-stat-number">{dashboardData.statistics.totalProjects}</h3>
                <p className="modern-stat-label">Proje</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modern Widgets */}
      <div className="row">
        {/* Son Duyurular Widget */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="modern-widget">
            <div className="modern-widget-header">
              <div className="modern-widget-title">
                <i className="bx bxs-megaphone"></i>
                <h4>Son Duyurular</h4>
              </div>
              <button 
                className="modern-widget-action"
                onClick={() => navigate('/duyurular')}
              >
                <i className="bx bx-right-arrow-alt"></i>
              </button>
            </div>
            <div className="modern-widget-body">
              {dashboardData.announcements.length > 0 ? (
                <div className="modern-activity-list">
                  {dashboardData.announcements.slice(0, 4).map((announcement, index) => (
                    <div key={index} className="modern-activity-item">
                      <div className="modern-activity-icon">
                        <i className="bx bxs-megaphone"></i>
                      </div>
                      <div className="modern-activity-content">
                        <h6 className="modern-activity-title">{announcement.title}</h6>
                        <p className="modern-activity-meta">
                          {new Date(announcement.createdAt).toLocaleDateString('tr-TR', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                          })} • 
                          {announcement.author?.firstName} {announcement.author?.lastName}
                        </p>
                        {announcement.content && (
                          <p className="modern-activity-description">
                            {announcement.content.length > 100 
                              ? announcement.content.substring(0, 100) + '...' 
                              : announcement.content
                            }
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="modern-empty-state">
                  <i className="bx bxs-megaphone"></i>
                  <p>Henüz duyuru bulunmuyor</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Son Aktivite Widget */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="modern-widget">
            <div className="modern-widget-header">
              <div className="modern-widget-title">
                <i className="bx bxs-activity"></i>
                <h4>Son Aktivite</h4>
              </div>
            </div>
            <div className="modern-widget-body">
              {dashboardData.recentActivity.length > 0 ? (
                <div className="modern-activity-list">
                  {dashboardData.recentActivity.slice(0, 5).map((activity, index) => (
                    <div key={index} className="modern-activity-item">
                      <div className={`modern-activity-icon ${activity.type}`}>
                        <i className={`bx ${activity.type === 'announcement' ? 'bxs-megaphone' : 'bxs-file-doc'}`}></i>
                      </div>
                      <div className="modern-activity-content">
                        <h6 className="modern-activity-title">{activity.title}</h6>
                        <p className="modern-activity-meta">
                          {activity.date} • {activity.author}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="modern-empty-state">
                  <i className="bx bxs-activity"></i>
                  <p>Henüz aktivite bulunmuyor</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Son Bir Ayda Doğum Günü Olanlar Widget */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="modern-widget">
            <div className="modern-widget-header">
              <div className="modern-widget-title">
                <i className="bx bxs-gift"></i>
                <h4>Son Bir Ayda Doğum Günü Olanlar</h4>
              </div>
            </div>
            <div className="modern-widget-body">
              {dashboardData.birthdays.length > 0 ? (
                <div className="modern-birthday-list">
                  {dashboardData.birthdays.map((person, index) => {
                    const birthDate = new Date(person.birthDate);
                    const thisYearBirthday = new Date(new Date().getFullYear(), birthDate.getMonth(), birthDate.getDate());
                    const isThisYear = thisYearBirthday <= new Date();
                    const displayDate = isThisYear ? thisYearBirthday : new Date(new Date().getFullYear() - 1, birthDate.getMonth(), birthDate.getDate());
                    
                    return (
                      <div key={index} className="modern-birthday-item">
                        <div className="modern-birthday-avatar">
                          <i className="bx bxs-gift"></i>
                        </div>
                        <div className="modern-birthday-content">
                          <h6 className="modern-birthday-name">{person.firstName} {person.lastName}</h6>
                          <p className="modern-birthday-department">{person.department}</p>
                          <small className="modern-birthday-date">
                            {displayDate.toLocaleDateString('tr-TR', { 
                              day: 'numeric', 
                              month: 'long' 
                            })}
                          </small>
                        </div>
                        <div className="modern-birthday-badge">
                          <i className="bx bxs-cake"></i>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="modern-empty-state">
                  <i className="bx bxs-gift"></i>
                  <p>Son bir ayda doğum günü olan yoktur</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Hızlı Erişim Widget */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="modern-widget">
            <div className="modern-widget-header">
              <div className="modern-widget-title">
                <i className="bx bxs-zap"></i>
                <h4>Hızlı Erişim</h4>
              </div>
            </div>
            <div className="modern-widget-body">
              <div className="modern-quick-links">
                <button 
                  className="modern-quick-link"
                  onClick={() => navigate('/duyurular')}
                >
                  <i className="bx bxs-megaphone"></i>
                  <span>Duyurular</span>
                </button>
                <button 
                  className="modern-quick-link"
                  onClick={() => navigate('/dokumanlar')}
                >
                  <i className="bx bxs-file-doc"></i>
                  <span>Dokümanlar</span>
                </button>
                <button 
                  className="modern-quick-link"
                  onClick={() => navigate('/profil')}
                >
                  <i className="bx bxs-user"></i>
                  <span>Profil</span>
                </button>
                <button 
                  className="modern-quick-link"
                  onClick={() => navigate('/personel')}
                >
                  <i className="bx bxs-group"></i>
                  <span>Personel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DashboardPage; 